import React, { useState, useEffect, useMemo } from "react";
import { AppProvider, useAppContext } from "@/AppContext";
import { ReactFlowProvider } from "@xyflow/react";
import { useLocation, useParams } from "react-router-dom";
import PageTop from "@/Pages/Project/PageTop";
import PageSeletor from "@/Pages/Project/Flow/Right/PageSeleltor";
import { fieldMap } from "@/config/dataMap";
// import { fieldMap } from "@/constants/dataMap";
import {typeMap4} from "@/constants/dataMap";
import { rebuildFormula } from "@/config/func";
import { jobs,getSubJob,getJob,getSubJobs } from "@/services/common";
import userInfo from "@/Components/user";
import { Button, message, Dropdown, Checkbox, Spin } from "antd";
import "./../index.less";
import ReactJson from "react-json-view";
import { CopyOutlined, DownOutlined, CaretDownOutlined, CaretRightOutlined } from "@ant-design/icons";
import { designValue, getDesignValue, actList, getActValue } from "@/services/design";
import dayjs from "dayjs";
import { useCompareData } from "../TaskDate/ResultPageFrame";

// 引擎返回的 JSON 文本可能包含非法 NaN（与结果抽屉解析一致），解析前统一替换为 0，避免 JSON.parse 崩溃
const jsonParseSafe = (str: any, fallback: any = {}) => {
  if (typeof str !== "string") return str ?? fallback;
  try {
    return JSON.parse(str.replace(/NaN/g, "0"));
  } catch (e) {
    try {
      return JSON.parse(str);
    } catch (e2) {
      return fallback;
    }
  }
};

// 塔板效率表格样式（与 ElementParamCompare 的 .effTable 一致）
const effTableStyle = {
  table: { width: "100%", borderCollapse: "collapse", fontSize: 16, color: "#333" } as React.CSSProperties,
  th: {
    border: "1px solid #e5e5e5",
    padding: "8px 12px",
    textAlign: "center" as const,
    background: "#f2f4f8",
    color: "#165DFF",
    fontWeight: 600,
    whiteSpace: "nowrap" as const,
  } as React.CSSProperties,
  td: { border: "1px solid #e5e5e5", padding: "8px 12px", textAlign: "center" as const, verticalAlign: "middle" as const } as React.CSSProperties,
};

const Component = (props: any) => {
  const { job_id, type, subJobid, item_name } = props;
  const { state } = useAppContext();
  const location = useLocation();
  const params = useParams<{ k: string; f: string; j: string }>();

  const [tabList, setTabList] = useState<{ key: any; label: any }[]>([]);
  const [activeTab, setActiveTab] = useState<any>("");
  const [taskInputData, setTaskInputData] = useState<any>(null);
  const [activeElement, setActiveElement] = useState<string | null>(null);
  const [activeStream, setActiveStream] = useState<string | null>(null);
  const [input, setInput] = useState<any>({});
  const [showFullInput, setShowFullInput] = useState(false);
  const [isDeviceOpen, setIsDeviceOpen] = useState(true);
  const [isStreamOpen, setIsStreamOpen] = useState(false);
  const [streamSearch, setStreamSearch] = useState("");
  const [expandedDeviceTypes, setExpandedDeviceTypes] = useState<Record<string, boolean>>({});

  // 对比功能
  const [dataList, setDataList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [filterType, setFilterType] = useState<"all" | "design" | "actual" | "task" | "otherCalc">("all");
  // 实际值存储列表（actList 接口获取，[{ id, name }]）
  const [actListData, setActListData] = useState<any[]>([]);
  // 对比数据由父组件 Context 统一管理（与单元操作/流股同步）
  const { compareItems, setCompareItems } = useCompareData();
  // 对比项变更时同步下拉勾选状态（三处页面共享同一份对比状态）
  useEffect(() => {
    setSelectedIds(compareItems.map((item: any) => item.id));
  }, [compareItems]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [taskDataList, setTaskDataList] = useState<any[]>([]); // 任务数据列表
  const [confirmLoading, setConfirmLoading] = useState(false); // 确认选择时的 loading 状态
  const [otherCalcResults, setOtherCalcResults] = useState<any[]>([]); // 当前元件其他计算结果
    const [otherCalcLoading, setOtherCalcLoading] = useState(false); // 加载其他计算结果的状态
  // 获取对比列表
  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await designValue({ flow_id: params.f }, userInfo.access_token);
      setDataList(res.data || []);
    } catch (err) {
      console.error("获取失败", err);
    } finally {
      setLoading(false);
    }
  };
  // 获取任务数据
      const fetchTaskData = async () => {
          setLoading(true);
          try {
              const res = await jobs({ flow_id: params.f, page: 1, perPage: 1000 }, userInfo.access_token);
              const allTaskData = res.data.data || [];
            const filteredData = params.j || subJobid
                ? allTaskData.filter((item: any) => String(item.id) !== String(params.j || subJobid))
                : allTaskData;
            // 过滤掉计算失败或未计算的任务（status 不是 "done" 的排除）
            const successData = filteredData.filter((item: any) => item.status === "done");
            setTaskDataList(successData);
          } catch (err) {
              console.error("获取任务数据失败", err);
          } finally {
              setLoading(false);
          }
      };
      // 获取当前元件其他计算结果
        const fetchOtherCalcResults = async () => {
          if (type !== 'subJob' || !item_name) return;
          setOtherCalcLoading(true);
          try {
            const res = await getSubJobs(
              {
                job_id: subJobid,  // 使用 flow_id 而不是 job_id
                name: item_name,
              },
              userInfo.access_token,
            );
            console.log("res",res.data);
            if (res.status === 200) {
              // 过滤掉当前任务，并且过滤掉计算失败或未计算的结果
              const filteredResults = res.data.filter((item: any) => 
                String(item.id) !== String(params.j || job_id) && item.status === "done"
              );
              setOtherCalcResults(filteredResults);
              console.log("filteredResults",filteredResults);
            }
          } catch (err) {
            console.error("获取其他计算结果失败", err);
          } finally {
            setOtherCalcLoading(false);
          }
        };

      // 获取当前组合计算的其他运行结果（type=multiJobs：同组合名多次运行中，除当前运行外的其他次）
        const fetchComboOtherCalcResults = async () => {
          if (type !== 'multiJobs') return;
          setOtherCalcLoading(true);
          try {
            const res = await getSubJobs({ job_id: subJobid }, userInfo.access_token);
            if (res.status === 200) {
              const list = res.data || [];
              // 当前运行所在组合名：以当前 subjob(id=job_id) 的行记录为准
              const cur = list.find(
                (item: any) => String(item.id) === String(job_id) && item.type === 'multi',
              );
              if (!cur) {
                setOtherCalcResults([]);
                return;
              }
              const filteredResults = list.filter(
                (item: any) =>
                  item.type === 'multi' &&
                  item.name === cur.name &&
                  String(item.id) !== String(job_id) &&
                  item.status === 'done',
              );
              setOtherCalcResults(filteredResults);
            }
          } catch (err) {
            console.error("获取组合计算其他运行结果失败", err);
          } finally {
            setOtherCalcLoading(false);
          }
        };

      // 获取实际值存储列表
        const fetchActList = async () => {
          try {
            const res = await actList(userInfo.access_token);
            // 返回结构为 { records: [{ id, name }] }
            setActListData(res.data?.records || []);
            console.log("实际值存储列表:", res.data);
          } catch (err) {
            console.error("获取实际值存储列表失败", err);
            setActListData([]);
          }
        };

  const handleDropdownOpen = (open: boolean) => {
    setDropdownOpen(open);
    if (open) {
      fetchData();
      fetchTaskData();
      fetchActList();
      if (type === 'subJob' && item_name) {
        fetchOtherCalcResults();
      } else if (type === 'multiJobs') {
        fetchComboOtherCalcResults();
      }
    }
  };

  const filteredList = useMemo(() => {
          // 实际值存储项：actList 接口返回的存储工况记录
          const actItems = actListData.map((rec) => ({
            id: `act-${rec.id}`,
            storeId: rec.id,
            name: rec.name,
            source: 'act',
          }));
          if (filterType === "all") {
              // 全部：显示设计值 + 实际值 + 任务数据
              return [
                  ...dataList.map(item => ({ ...item, source: 'design' })),
                  ...actItems,
                  ...taskDataList.map(item => ({ ...item, source: 'task' })),
                  ...otherCalcResults.map(item => ({ ...item, source: 'otherCalc' })),
              ];
          } else if (filterType === "design") {
              return dataList.filter(item => item.type === "design").map(item => ({ ...item, source: 'design' }));
          } else if (filterType === "actual") {
              return actItems;
          } else if (filterType === "task") {
              return taskDataList.map(item => ({ ...item, source: 'task' }));
          }else if (filterType === "otherCalc") {
             // 当前元件其他计算结果
             return otherCalcResults.map(item => ({ ...item, source: 'otherCalc' }));
         }
          return [];
      }, [dataList, taskDataList,otherCalcResults, filterType, actListData]);

  const toggleSelect = (id: string) => {
    setSelectedIds((prev) => (prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]));
  };

  // 把输出流股数据转换成与单元操作/流股页一致的对比格式（供这些页面对比展示）
  // keepNull=true 时（时间范围运行数据）缺失字段保留 null，显示为 "-"，不用 0 替换
  // 运行数据的 molar_frac 是对象数组 [{ "H₂S": 0.000003 }, ...]，且不一定覆盖所有组分；
  // 按输入组分顺序映射为 materials 数组，没有对应值的组分摩尔分率为 null（显示为 "-"）
  const buildTimeRangeMaterials = (s: any) => {
    const refStream = (input?.inputs?.streams || []).find((item: any) => item?.materials?.length);
    const inputMats = refStream?.materials || [];
    const fracMap: Record<string, number> = {};
    (s.molar_frac || []).forEach((item: any) => {
      if (item && typeof item === "object") {
        Object.entries(item).forEach(([name, v]) => {
          if (v != null) fracMap[name] = Number(v);
        });
      }
    });
    return inputMats.map((mat: any) => {
      const key = mat?.name ? rebuildFormula(String(mat?.name)) : "";
      const v = fracMap[key] ?? fracMap[mat?.name];
      return { molar_frac: v ?? null };
    });
  };

  const convertOutputStreams = (outputData: any, keepNull = false) =>
    (outputData.streams || []).map((s: any) => ({
      name: s.name,
      params: {
        f: s.f_kg_per_h ?? (keepNull ? null : 0),
        f_unit: "kg/h",
        t: s.T_C ?? (keepNull ? null : 0),
        t_unit: "C",
        p: s.P_MPa ?? (keepNull ? null : 0),
        p_unit: "MPa",
      },
      materials: keepNull ? buildTimeRangeMaterials(s) : (s.molar_frac || []).map((mf: number) => ({
        molar_frac: mf ?? 0,
      })),
      vf: s.vf,
      H: s.H,
      mass_frac: s.mass_frac,
      f_mol_per_h: s.f_mol_per_h,
      f_nm3_per_h: s.f_nm3_per_h,
      f_m3_per_h: s.f_m3_per_h,
      f_l_per_h: s.f_l_per_h,
    }));

const handleConfirm = async () => {
        setConfirmLoading(true); // 开始 loading
        try {
            const fetchPromises = selectedIds.map(async (id) => {
                try {
                    // 在所有数据源中查找对应的项目，判断来源（不依赖 filteredList）
                    const taskItem = taskDataList.find(item => String(item.id) === String(id));
                    const otherCalcItem = otherCalcResults.find(item => String(item.id) === String(id));
                    const actRec = actListData.find(r => `act-${r.id}` === id);

                    if (actRec) {
                        // 实际值存储项：通过 getActValue 获取存储的实际值数据
                        const res = await getActValue(actRec.id, userInfo.access_token);
                        const actData = res.data.result; // 详情数据（结构同 realtime 返回的 { input, output }）
                        console.log("实际值存储详情:", actData);
                        const outputData = actData.output;
                        const inputData = actData.input;
                        const data = {
                            id,
                            values: {
                                name: actRec.name,
                                mix_input: inputData,
                                fullOutput: { streams: convertOutputStreams(outputData, true), elements: outputData.elements || [] }, // 输出换算数据，供单元操作/流股页对比展示
                                rawInput: inputData, // 接口返回的原始 input
                                rawOutput: outputData, // 接口返回的原始 output
                            },
                            outputElements: outputData.elements || [], // 供分布数据组件对比使用
                            type: "actual",
                            name: actRec.name,
                        };
                        return data;
                    } else if (taskItem) {
                        // 任务数据：使用 getJob 接口
                        const res = await getJob(id, userInfo.access_token);
                        // 过滤掉计算失败或未计算的任务
                        if (res.data.status !== "done") return null;
                        const outputData = jsonParseSafe(res.data.output);
                        const data ={
                            id:res.data.id,
                            values:{
                            name:res.data.name,  
                            mix_input :jsonParseSafe(res.data.input),
                            fullOutput: { streams: convertOutputStreams(outputData), elements: outputData.elements || [] }, // 输出换算数据，供单元操作/流股页对比展示
                            } ,
                            outputElements: outputData.elements || [], // 供分布数据组件对比使用
                            type:"task"
                        }
                        return data;
                    } else if (otherCalcItem) {
                        // 当前元件其他计算结果：使用 getSubJob 接口
                        const res = await getSubJob(id, userInfo.access_token);
                        // 过滤掉计算失败或未计算的任务
                        if (res.data.status !== "done") return null;
                        console.log("其他计算结果:", res.data);
                        const outputData = jsonParseSafe(res.data.output);
                        const data ={
                            id: res.data.id,
                            values: {
                                name: res.data.name,
                                mix_input: res.data.input,
                                fullOutput: { streams: convertOutputStreams(outputData), elements: outputData.elements || [] }, // 输出换算数据，供单元操作/流股页对比展示
                            },
                            created_at: res.data.created_at,
                            outputElements: outputData.elements || [], // 供分布数据组件对比使用
                            type: "otherCalc",
                        };
                        return data;
                    } else {
                        // 设计值/实际值：使用 getDesignValue 接口
                        const res = await getDesignValue(id, userInfo.access_token);
                        return res.data;
                    }
                } catch (err) {
                    console.error("获取失败", id, err);
                    return null;
                }
            });
            // 2. 等待所有请求完成
            let selectedItems = await Promise.all(fetchPromises);
            // 3. 过滤掉失败的
            selectedItems = selectedItems.filter(Boolean);
            setCompareItems(selectedItems);
            setDropdownOpen(false);
        } finally {
            setConfirmLoading(false); // 结束 loading
        }
    };

  // 加载任务数据
  useEffect(() => {
    if (type === "job") {
      getJob(params.j || job_id, userInfo.access_token).then((r) => {
      if (r.status === 200) {
        const data = {
          name: r.data.name,
          flow_id: r.data.flow_id,
          description: r.data.description,
          inputs: JSON.parse(r.data.input),
        };
        setInput(data);
      }
    });
    } else if (type === "subJob") {
      getSubJob(job_id, userInfo.access_token).then((r) => {
        if (r.status === 200) {
          const data = {
            name: r.data.name,
            // flow_id: r.data.flow_id,
            // description: r.data.description,
            inputs: r.data.input
          };
          setInput(data);
          // setResponse(response0423.response);
        }
      });
    }else if(type==='multiJobs'){
      getSubJob(job_id, userInfo.access_token).then((r) => {
        if (r.status === 200) {
          setInput({
            name: r.data.name,
            // flow_id: r.data.flow_id,
            // description: r.data.description,
            inputs: r.data.input
          });
        }
      });
    }
  }, [job_id, type]);

  useEffect(() => {
    if (input?.inputs) {
      setTaskInputData(input);
      const tabs = generateTabListFromData(input);
      setTabList(tabs);
      if (tabs.length > 0) setActiveTab(tabs[0].key);
    }
  }, [input]);

  // 生成 Tab
  const generateTabListFromData = (data: any) => {
    if (!data?.inputs?.elements) return [];
    const sections = data.inputs.elements.map((el) => el.section).filter(Boolean);
    return Array.from(new Set(sections)).map((sec) => ({ key: sec, label: sec }));
  };

  // 获取全部设备/流股（不再按 Tab section 过滤）
  const elements = useMemo(() => {
    if (!taskInputData?.inputs?.elements) return [];
    console.log("taskInputData.inputs.elements:", taskInputData.inputs.elements);
    return taskInputData.inputs.elements;
  }, [taskInputData]);

  const streams = useMemo(() => {
    //全部流股，包含入和出流股
    // if (!taskInputData?.inputs?.streams) return [];
    // return taskInputData.inputs.streams;
    if (!taskInputData?.inputs?.elements) return [];
    const names = new Set<string>();
    const result: any[] = [];
    taskInputData.inputs.elements.forEach((el: any) => {
      el.inputStreams?.forEach((s: any) => {
        if (!names.has(s.name)) {
          names.add(s.name);
          result.push(s);
        }
      });
    });
    return result;
  }, [taskInputData]);

  // 设备分类（按 type 分组）
  const groupedElements = useMemo(() => {
    const groups: Record<string, any[]> = {};
    elements.forEach((el) => {
      const type = el.type || "其他";
      if (!groups[type]) {
        groups[type] = [];
      }
      groups[type].push(el);
    });
    return groups;
  }, [elements]);

  // 获取类型的中文名称
  const getTypeNameCN = (type: string) => {
    return typeMap4[type] || type;
  };

  // 流股搜索过滤
  const filteredStreams = useMemo(() => {
    if (!streamSearch) return streams;
    return streams.filter((s) =>
      s.name.toLowerCase().includes(streamSearch.toLowerCase())
    );
  }, [streams, streamSearch]);

  // 获取当前高亮设备所在的分类
  const currentElementType = useMemo(() => {
    if (!activeElement) return null;
    const el = elements.find((e) => e.name === activeElement);
    return el ? (el.type || "其他") : null;
  }, [activeElement, elements]);

  // 当活动设备变化时，自动展开其所属分类
  useEffect(() => {
    if (currentElementType && activeElement) {
      setExpandedDeviceTypes((prev) => ({
        ...prev,
        [currentElementType]: true,
      }));
    }
  }, [currentElementType, activeElement]);

  // 切换分类展开/折叠状态
  const toggleDeviceType = (type: string) => {
    setExpandedDeviceTypes((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));
  };

  useEffect(() => {
    if (taskInputData && !showFullInput) {
      const els = elements;
      const sts = streams;
      if (els.length) {
        setActiveElement(els[0].name);
        setActiveStream(null);
      } else if (sts.length) {
        setActiveStream(sts[0].name);
        setActiveElement(null);
      }
    }
  }, [taskInputData, showFullInput]);

  // ==============================================
  //  获取当前设备 / 流股 以及 所有对比数据
  // ==============================================
  const currentEl = activeElement
    ? taskInputData?.inputs?.elements?.find((e) => e.name === activeElement)
    : null;

  const currentSt = activeStream
    ? taskInputData?.inputs?.streams?.find((s) => s.name === activeStream)
    : null;

  // 全组分列表（解析塔板效率 spec 中组分索引用，索引从 1 开始）
  const globalMaterials = state?.curFlow?.global_data?.materials || [];

  // 优先用各页面统一上报的完整输入数据（fullInput），否则回退 mix_input
  const compareElementList = compareItems.map(
    (item) =>
      item?.values?.fullInput?.elements?.find((e) => e.name === activeElement) ||
      item?.values?.mix_input?.elements?.find((e) => e.name === activeElement) ||
      null,
  );

  const compareStreamList = compareItems.map(
    (item) =>
      item?.values?.fullInput?.streams?.find((s) => s.name === activeStream) ||
      item?.values?.mix_input?.streams?.find((s) => s.name === activeStream) ||
      null,
  );

  // 表格列构建
  const tableColumns = [
    { title: "参数名称", key: "label" },
    { title: "当前值", key: "current" },
    ...compareItems.map((item, i) => ({
      // title: `${item.type === "design" ? "设计值" : "实际值"}(${item.id})`,
      title: `${item.type === "task" ? item.values.name 
        : item.type === "otherCalc"
        ? `${item.values.name} (${item.created_at ? dayjs(item.created_at).add(8, "hours").format("YYYY-MM-DD HH:mm:ss") : ''})`
        : item.type === "design" ? `设计值 (${item.id})` : (item.name || item.values?.name) || (item.type === "timeRange" ? (item.fullDay ? `运行数据 ${item.date}` : `运行数据 ${item.startTime} ~ ${item.endTime}`) : `运行数据 (${item.id})`)}`,
      key: `compare_${i}`,
      type: item.type,
    })),
  ];

  // 判断当前值与对比值是否有差异（用于整行标红）
  const valuesDiffer = (current: any, compare: any): boolean => {
    // 任一侧缺失（页面显示为 "-"）都不算差异，不标红
    const curMissing = current === "-" || current === null || current === undefined;
    const cmpMissing = compare === "-" || compare === null || compare === undefined;
    if (curMissing || cmpMissing) return false;
    const curStr = String(current ?? "");
    const cmpStr = String(compare ?? "");
    const curNum = parseFloat(curStr);
    const cmpNum = parseFloat(cmpStr);
    const curIsNum = !isNaN(curNum);
    const cmpIsNum = !isNaN(cmpNum);
    if (curIsNum && cmpIsNum) {
      // 数值比较（parseFloat 会忽略单位与误差百分比后缀）
      // 用精确比较而非容差：浮点误差导致的微小差异（如 0.25470000000000002 vs 0.2547）
      // 页面显示上肉眼可见不同，也应标红，与显示保持一致
      return curNum !== cmpNum;
    }
    // 非数值：字符串直接比较
    return curStr !== cmpStr;
  };

  // 生成设备参数表格行
  const getElementTableRows = () => {
    if (!currentEl) return [];
    const rows = [];
    const cfg = fieldMap.elements;
    const data = { ...currentEl, ...currentEl.params };

    // // 计算误差百分比
    // const calculateErrorPercent = (compareValue: number, calcValue: number): string => {
    //   if (compareValue === 0 && calcValue === 0) return "0%";
    //   if (compareValue === 0 && calcValue !== 0) return "100%";
    //   const errorPercent = ((calcValue - compareValue) / compareValue) * 100;
    //   return `${errorPercent.toFixed(2)}%`;
    // };

    Object.entries(cfg).forEach(([key, c]) => {
      if (data[key] === undefined || data[key] === null) return;
      const val = c.enum?.[data[key]] ?? data[key];
      const unit = data[c.unitKey] ?? c.unit ?? "";

      rows.push({
        label: c.name,
        current: `${val} ${unit}`,
        compares: compareElementList.map((cel) => {
          if (!cel) return "-";
          const d = { ...cel, ...cel.params };
          const v = c.enum?.[d[key]] ?? d[key];
          if (v === undefined || v === null) return "-";
          // // 判断是否为数值，只有数值才计算误差百分比
          // const currentNum = parseFloat(val);
          // const compareNum = parseFloat(v);
          // const isNumeric = !isNaN(currentNum) && !isNaN(compareNum);
          
          // if (isNumeric) {
          //   const errorPercent = (compareNum !== 0)
          //     ? calculateErrorPercent(compareNum, currentNum)
          //     : (currentNum === 0) ? "0.00%" : "100.00%";
          //   return `${v} ${unit}(${errorPercent})`;
          // } else {
          //   // 非数值类型，直接显示
          //   return `${v} ${unit}`;
          // }
          return `${v} ${unit}`;
        }),
      });
    });

    // 进料位置
    if (currentEl.params.Ns && currentEl.inputStreams) {
      currentEl.inputStreams.forEach((s, i) => {
        rows.push({
          label: `${s.name} 进料位置`,
          current: currentEl.params.Ns[i] ?? "-",
          compares: compareElementList.map((cel) => cel?.params?.Ns?.[i] ?? "-"),
        });
      });
    }

    // 出料位置
    if (currentEl.params.No && currentEl.outputStreams) {
      currentEl.outputStreams.forEach((s, i) => {
        rows.push({
          label: `${s.name} 出料位置`,
          current: currentEl.params.No[i] ?? "-",
          compares: compareElementList.map((cel) => cel?.params?.No?.[i] ?? "-"),
        });
      });
    }

    // 入口流股 / 出口流股（换热器显示冷热属性，其他元件仅列名称；塔除外）
    if (currentEl.type === "ShellAndTubeExchanger") {
      const streamValue = (s: any) => s?.streamAttribute || "—";
      if (currentEl.inputStreams?.length > 0) {
        currentEl.inputStreams.forEach((s: any) => {
          rows.push({
            label: `入口流股 - ${s.name}`,
            current: streamValue(s),
            compares: compareElementList.map((cel) => {
              if (!cel) return "-";
              const cs = cel.inputStreams?.find((x: any) => x.name === s.name);
              return cs ? streamValue(cs) : "-";
            }),
          });
        });
      }
      if (currentEl.outputStreams?.length > 0) {
        currentEl.outputStreams.forEach((s: any) => {
          rows.push({
            label: `出口流股 - ${s.name}`,
            current: streamValue(s),
            compares: compareElementList.map((cel) => {
              if (!cel) return "-";
              const cs = cel.outputStreams?.find((x: any) => x.name === s.name);
              return cs ? streamValue(cs) : "-";
            }),
          });
        });
      }
    }

    // 输出流量
    if (currentEl.params?.output_f && currentEl.outputStreams?.length > 0) {
      currentEl.outputStreams.forEach((s: any, idx: number) => {
        if (currentEl.params.output_f[idx] === undefined) return;
        rows.push({
          label: `输出流量 - ${s.name}`,
          current: `${currentEl.params.output_f[idx]}${currentEl.params.f_unit ? ` ${currentEl.params.f_unit}` : ""}`,
          compares: compareElementList.map((cel) => {
            if (!cel) return "-";
            const v = cel?.params?.output_f?.[idx];
            if (v === undefined) return "-";
            return `${v}${cel.params?.f_unit ? ` ${cel.params.f_unit}` : ""}`;
          }),
        });
      });
    }

    // 支持任意多组 塔板效率
    if (currentEl.params.eff && currentEl.params.eff.length > 0) {
      currentEl.params.eff.forEach((eff, idx) => {
        const prefix = idx + 1;
        rows.push(
          {
            label: `塔板效率 ${prefix} - 起始塔板`,
            current: eff.start ?? "-",
            compares: compareElementList.map((c) => c?.params?.eff?.[idx]?.start ?? "-"),
          },
          {
            label: `塔板效率 ${prefix} - 结束塔板`,
            current: eff.end ?? "-",
            compares: compareElementList.map((c) => c?.params?.eff?.[idx]?.end ?? "-"),
          },
          {
            label: `塔板效率 ${prefix} - 效率值`,
            current: eff.value ?? "-",
            compares: compareElementList.map((c) => c?.params?.eff?.[idx]?.value ?? "-"),
          },
        );
      });
    }

    return rows;
  };

  // 生成流股参数表格行
  const getStreamTableRows = () => {
    if (!currentSt) return [];
    const rows = [];
    const cfg = fieldMap.streams;
    const data = currentSt.params;

    // // 计算误差百分比
    // const calculateErrorPercent = (compareValue: number, calcValue: number): string => {
    //   if (compareValue === 0 && calcValue === 0) return "0.00%";
    //   if (compareValue === 0 && calcValue !== 0) return "100.00%";
    //   const errorPercent = ((calcValue - compareValue) / compareValue) * 100;
    //   return `${errorPercent.toFixed(2)}%`;
    // };

    Object.entries(cfg).forEach(([key, c]) => {
      if (data[key] === undefined || data[key] === null) return;
      const val = c.enum?.[data[key]] ?? data[key];
      const unit = data[c.unitKey] ?? c.unit ?? "";
      rows.push({
        label: c.name,
        current: `${val} ${unit}`,
        compares: compareStreamList.map(cst => {
          if (!cst) return "-";
          const v = c.enum?.[cst.params[key]] ?? cst.params[key];
          if (v === undefined) return "-";
          // // 判断是否为数值，只有数值才计算误差百分比
          // const currentNum = parseFloat(val);
          // const compareNum = parseFloat(v);
          // const isNumeric = !isNaN(currentNum) && !isNaN(compareNum);
          
          // if (isNumeric) {
          //   const errorPercent = (compareNum !== 0)
          //     ? calculateErrorPercent(compareNum, currentNum)
          //     : (currentNum === 0) ? "0.00%" : "100.00%";
          //   return `${v} ${unit}(${errorPercent})`;
          // } else {
          //   // 非数值类型，直接显示
          //   return `${v} ${unit}`;
          // }
          return `${v} ${unit}`;
        }),
      });
    });

    // 组分
    if (currentSt.materials?.length) {
      currentSt.materials.forEach((mat, i) => {
        const name = mat.cas === "7732-18-5" ? "水" : mat.cas === "67-56-1" ? "甲醇" : mat.name;
        rows.push({
          label: `${rebuildFormula(name)} 摩尔分率`,
          current: mat.molar_frac,
          compares: compareStreamList.map((cst) => {
            const compareVal = cst?.materials?.[i]?.molar_frac;
            if (compareVal === undefined || compareVal === null) return "-";
            // // 判断是否为数值，只有数值才计算误差百分比
            // const currentNum = parseFloat(mat.molar_frac);
            // const compareNum = parseFloat(compareVal);
            // const isNumeric = !isNaN(currentNum) && !isNaN(compareNum);
            
            // if (isNumeric) {
            //   const errorPercent = (compareNum !== 0)
            //     ? calculateErrorPercent(compareNum, currentNum)
            //     : (currentNum === 0) ? "0.00%" : "100.00%";
            //   return `${compareVal}(${errorPercent})`;
            // } else {
            //   // 非数值类型，直接显示
            //   return `${compareVal}`;
            // }
            return `${compareVal}`;
          }),
        });
      });
    }

    return rows;
  };

  // ==============================================
  // 原始布局渲染函数（无对比时使用）
  // ==============================================
  const renderParamRows = (data: any, type: "elements" | "streams") => {
    if (!data) return null;
    const fieldConfig = fieldMap[type];
    let params: any = type === "streams" ? data.params : { ...data, ...data.params };
    
    return Object.entries(fieldConfig).map(([key, config]) => {
      if (params[key] === undefined || params[key] === null) return null;
      let value = config.enum?.[params[key]] ?? params[key];
      const unit = params[config.unitKey] ?? config.unit;
      return (
        <div key={key} className="paramRow">
          <span className="paramLabel">{config.name}</span>
          <span className="paramValue">
            {value} {unit && <span className="paramUnit">{unit}</span>}
          </span>
        </div>
      );
    });
  };

  const renderComponentRows = (materials: any[]) => {
    if (!materials || materials.length === 0) return null;
    return materials.map((mat: any) => (
      <div key={mat.cas} className="paramRow">
        <span className="paramLabel">
          {mat.cas === "7732-18-5"
            ? "水"
            : mat.cas === "67-56-1"
              ? "甲醇"
              : rebuildFormula(mat.name)}
        </span>
        <span className="paramValue">{mat.molar_frac}</span>
      </div>
    ));
  };

  const renderFeedPositions = (Ns: number[], inputStreams: any[]) => {
    if (!Ns || !inputStreams || Ns.length !== inputStreams.length) return null;
    return inputStreams.map((stream, idx) => (
      <div key={stream.name} className="paramRow">
        <span className="paramLabel">{`${stream.name} 进料位置`}</span>
        <span className="paramValue">{Ns[idx]}</span>
      </div>
    ));
  };

  const renderProductPositions = (No: number[], outputStreams: any[]) => {
    if (!No || !outputStreams || No.length !== outputStreams.length) return null;
    return outputStreams.map((stream, idx) => (
      <div key={stream.name} className="paramRow">
        <span className="paramLabel">{`${stream.name} 出料位置`}</span>
        <span className="paramValue">{No[idx]}</span>
      </div>
    ));
  };

  const elementRows = getElementTableRows();
  const streamRows = getStreamTableRows();
  const isCompareMode = compareItems.length > 0;

  // 复制
  const handleCopy = () => {
    navigator.clipboard
      .writeText(JSON.stringify(input, null, 2))
      .then(() => message.success("复制成功"));
  };

  // ==============================================
  // 下拉面板
  // ==============================================
  const dropdownContent = (
    <div
      style={{ width: type === 'subJob' ? 470 : 320, padding: 12, 
        // maxHeight: 400, overflow: "auto", 
        background: "#f0efefff" }}
    >
      <div style={{ display: "flex", gap: 6, marginBottom: 12, flexWrap: "wrap" }}>
        <Button
          size="small"
          type={filterType === "all" ? "primary" : "default"}
          onClick={() => setFilterType("all")}
        >
          全部
        </Button>
        <Button
          size="small"
          type={filterType === "design" ? "primary" : "default"}
          onClick={() => setFilterType("design")}
        >
          设计值
        </Button>
        <Button
          size="small"
          type={filterType === "actual" ? "primary" : "default"}
          onClick={() => setFilterType("actual")}
        >
          运行数据
        </Button>
        <Button size="small" type={filterType === "task" ? "primary" : "default"} onClick={() => setFilterType("task")}>其他任务</Button>
        {type === 'subJob' && (
                  <Button
                    size="small"
                    type={filterType === "otherCalc" ? "primary" : "default"}
                    onClick={() => {
                      setFilterType("otherCalc");
                      fetchOtherCalcResults();
                    }}
                  >
                    当前元件其他任务
                  </Button>
                )}
        {type === 'multiJobs' && (
          <Button
            size="small"
            type={filterType === "otherCalc" ? "primary" : "default"}
            onClick={() => {
              setFilterType("otherCalc");
              fetchComboOtherCalcResults();
            }}
          >
            当前组合计算其他任务
          </Button>
        )}
      </div>
      <div  style={{maxHeight:350, overflow: "auto"}} >
        {loading ? (
          <div style={{ textAlign: "center", padding: 20 }}>
            <Spin />
              </div>
        ) : filteredList.length === 0 ? (
          <div style={{ textAlign: "center", color: "#999" }}>暂无数据</div>
        ) : (
          filteredList.map((item) => (
            <div
              key={item.id}
              style={{
                padding: "8px 10px",
                border: "1px solid #eee",
                borderRadius: 4,
                marginBottom: 6,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <span>
                {item.source === 'task'? `${item.name || item.id}`
                : item.source === 'otherCalc'
                ? `${item.name || item.id} (${item.created_at ? dayjs(item.created_at).add(8, "hours").format("YYYY-MM-DD HH:mm:ss") : ''})`
                : item.source === 'act'
                ? `${item.name}`
                : `${item.type === "design" ? "设计值" : "运行数据"} ${item.id}`}
              </span>
              <Checkbox
                checked={selectedIds.includes(item.id)}
                onChange={() => toggleSelect(item.id)}
              />
            </div>
          ))
        )}
      </div>
      <div style={{ marginTop: 10, display: "flex", justifyContent: "space-between" }}>
        <span>已选：{selectedIds.length} 项</span>
        <Button type="primary" size="small" onClick={handleConfirm} loading={confirmLoading}>
          {confirmLoading ? "正在对比..." : "确认选择"}
        </Button>
      </div>
    </div>
  );

  return (
    <ReactFlowProvider>
      {state.curFlow && state.curProject && (
        <>
          <div className="mainContent" style={{ overflow: "hidden",height:"calc(100vh - 85px)" }}>
            <div className="mainTask" style={{ width: "100%" }}>
              {/* 初始版分组 */}
              {/* {tabList.length > 0 && (
                <div className="tabContainer">
                  <div className="tabTitle">计算参数：</div>
                  <div className="tabButtonGroup">
                    {tabList.map((tab) => (
                      <div
                        key={tab.key}
                        onClick={() => {
                          setShowFullInput(false);
                          setActiveTab(tab.key);
                        }}
                        className={`tabItem ${activeTab === tab.key ? "tabActive" : ""}`}
                      >
                        <span className="tabText">{tab.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )} */}

              <div className="contentLayout">
                <div className="sidebar">
                  <Button
                    type="primary"
                    style={{ marginBottom: 12, width: "100%" }}
                    onClick={() => {
                      setShowFullInput(true);
                      setActiveElement(null);
                      setActiveStream(null);
                    }}
                  >
                    查看完整输入
                  </Button>
                  <Dropdown
                    overlay={dropdownContent}
                    trigger={["click"]}
                    open={dropdownOpen}
                    onOpenChange={handleDropdownOpen}
                    placement="bottomRight"
                    overlayStyle={{ zIndex: 100002 }}
                  >
                    <Button type="primary" style={{ marginBottom: 12, width: "100%" }}>
                      对比设计值/运行数据 <DownOutlined />
                    </Button>
                  </Dropdown>

                  {/* {compareItems.length > 0 && (
                    <div style={{ marginBottom: 16, fontSize: 12, color: "#165DFF" }}>
                      已对比 {compareItems.length} 项
                    </div>
                  )} */}

                  <div className="sidebarSection">
                    <div
                      className="sidebarTitle"
                      onClick={() => setIsDeviceOpen(!isDeviceOpen)}
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      设备{" "}
                      {isDeviceOpen ? <CaretDownOutlined /> : <CaretRightOutlined />}
                    </div>
                    <div
                      className="sidebarList"
                      style={{ display: isDeviceOpen ? "block" : "none" }}
                    >
                      {Object.entries(groupedElements).map(([type, typeElements]) => {
                        const isExpanded = expandedDeviceTypes[type] ?? (activeElement && type === currentElementType); // 只有在选中设备且是当前分类时才默认展开
                        const isCurrentType = type === currentElementType;
                        return (
                          <div key={type} className="device-type-group">
                            <div
                              className="device-type-title"
                              onClick={() => toggleDeviceType(type)}
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                backgroundColor: isCurrentType ? "#e6f7ff" : "#f5f5f5",
                                color: isCurrentType ? "#165DFF" : "#666",
                                fontSize: 14,
                                fontWeight: 590,
                              }}
                            >
                              <span>{getTypeNameCN(type)} ({typeElements.length})</span>
                              {isExpanded ? <CaretDownOutlined /> : <CaretRightOutlined />}
                            </div>
                            {isExpanded && (
                              <div className="device-type-items">
                                {typeElements.map((el) => (
                                  <div
                                    key={el.name}
                                    onClick={() => {
                                      setShowFullInput(false);
                                      setActiveElement(el.name);
                                      setActiveStream(null);
                                    }}
                                    className={`sidebarItem ${activeElement === el.name ? "sidebarItemActive" : ""}`}
                                    style={{
                                      backgroundColor: activeElement === el.name ? "#e6f7ff" : "transparent",
                                      color: activeElement === el.name ? "#165DFF" : "#666",
                                    }}
                                  >
                                    {el.name}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <div className="sidebarSection">
                    <div
                      className="sidebarTitle"
                      onClick={() => setIsStreamOpen(!isStreamOpen)}
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      流股{" "}
                      {isStreamOpen ? <CaretDownOutlined /> : <CaretRightOutlined />}
                    </div>
                    <div
                      className="sidebarList"
                      style={{ display: isStreamOpen ? "block" : "none" }}
                    >
                      <div className="stream-search-box">
                        <input
                          type="text"
                          className="stream-search-input"
                          placeholder="搜索流股..."
                          value={streamSearch}
                          onChange={(e) => setStreamSearch(e.target.value)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                      {filteredStreams.map((s) => (
                        <div
                          key={s.name}
                          onClick={() => {
                            setShowFullInput(false);
                            setActiveStream(s.name);
                            setActiveElement(null);
                          }}
                          className={`sidebarItem ${activeStream === s.name ? "sidebarItemActive" : ""}`}
                        >
                          {s.name}
                        </div>
                      ))}
                      {filteredStreams.length === 0 && streamSearch && (
                        <div className="sidebar-item-empty">暂无匹配的流股</div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="paramPanel">
                  {showFullInput ? (
                    <div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: 12,
                        }}
                      >
                        <h2 style={{ margin: 0 }}>完整输入数据</h2>
                        <Button icon={<CopyOutlined />} onClick={handleCopy}>
                          一键复制
                        </Button>
                      </div>
                      <ReactJson
                        src={input}
                        collapsed={false}
                        displayDataTypes={false}
                        enableClipboard={false}
                        indentWidth={2}
                        name={null}
                        style={{ fontSize: 13 }}
                      />
                    </div>
                  ) : isCompareMode ? (
                    // 有对比 → 表格展示
                    currentEl ? (
                      <div className="paramContent">
                        <h2 className="paramTitle">{currentEl.name} - 设备参数对比</h2>
                        <table className="compare-table">
                          <thead>
                            <tr>
                              {tableColumns.map((col) => (
                                <th key={col.key}>{col.title}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {elementRows.map((row, i) => {
                              const rowHasDiff = row.compares.some((v: any) => valuesDiffer(row.current, v));
                              return (
                              <tr key={i} className={rowHasDiff ? "compare-row-diff" : ""}>
                                <td>{row.label}</td>
                                <td className="compare-value-current">{row.current}</td>
                                {row.compares.map((v, j) => (
                                  <td
                                    key={j}
                                    className={
                                      compareItems[j]?.type === "design"
                                        ? "compare-value-design"
                                        : "compare-value-actual"
                                    }
                                  >
                                    {v}
                                  </td>
                                ))}
                              </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    ) : currentSt ? (
                      <div className="paramContent">
                        <h2 className="paramTitle">{currentSt.name} - 流股参数对比</h2>
                        <table className="compare-table">
                          <thead>
                            <tr>
                              {tableColumns.map((col) => (
                                <th key={col.key}>{col.title}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {streamRows.map((row, i) => {
                              const rowHasDiff = row.compares.some((v: any) => valuesDiffer(row.current, v));
                              return (
                              <tr key={i} className={rowHasDiff ? "compare-row-diff" : ""}>
                                <td>{row.label}</td>
                                <td className="compare-value-current">{row.current}</td>
                                {row.compares.map((v, j) => (
                                  <td
                                    key={j}
                                    className={
                                      compareItems[j]?.type === "design"
                                        ? "compare-value-design"
                                        : "compare-value-actual"
                                    }
                                  >
                                    {v}
                                  </td>
                                ))}
                              </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    ) : null
                  ) : // 无对比 → 原始布局
                    currentEl ? (
                      <div className="paramContent">
                        <h2 className="paramTitle">{currentEl.name} 参数</h2>
                      <div className="paramGrid">{renderParamRows(currentEl, "elements")}</div>

                        {currentEl.type === "ShellAndTubeExchanger" && currentEl.inputStreams?.length > 0 && (
                          <>
                            <h3 className="sectionTitle">入口流股</h3>
                            <div className="paramGrid">
                              {currentEl.inputStreams.map((s: any) => (
                                <div key={s.name} className="paramRow">
                                  <span className="paramLabel">{s.name}</span>
                                  <span className="paramValue">{s.streamAttribute}</span>
                                </div>
                              ))}
                            </div>
                          </>
                        )}

                        {currentEl.type === "ShellAndTubeExchanger" && currentEl.outputStreams?.length > 0 && (
                          <>
                            <h3 className="sectionTitle">出口流股</h3>
                            <div className="paramGrid">
                              {currentEl.outputStreams.map((s: any) => (
                                <div key={s.name} className="paramRow">
                                  <span className="paramLabel">{s.name}</span>
                                  <span className="paramValue">{s.streamAttribute}</span>
                                </div>
                              ))}
                            </div>
                          </>
                        )}

                        {currentEl.type !== "ShellAndTubeExchanger" && currentEl.type !== "DistilStrict" && currentEl.inputStreams?.length > 0 && (
                          <>
                            <h3 className="sectionTitle">入口流股</h3>
                            <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 30 }}>
                              {currentEl.inputStreams.map((s: any) => (
                                <span key={s.name} className="paramLabel">{s.name}</span>
                              ))}
                            </div>
                          </>
                        )}

                        {currentEl.type !== "ShellAndTubeExchanger" && currentEl.type !== "DistilStrict" && currentEl.outputStreams?.length > 0 && (
                          <>
                            <h3 className="sectionTitle">出口流股</h3>
                            <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 30 }}>
                              {currentEl.outputStreams.map((s: any) => (
                                <span key={s.name} className="paramLabel">{s.name}</span>
                              ))}
                            </div>
                          </>
                        )}

                        {currentEl.params?.output_f && currentEl.outputStreams?.length > 0 && (
                          <>
                            <h3 className="sectionTitle">输出流量</h3>
                            <div className="paramGrid">
                              {currentEl.outputStreams.map((s: any, idx: number) =>
                                currentEl.params.output_f[idx] !== undefined ? (
                                  <div key={s.name} className="paramRow">
                                    <span className="paramLabel">{s.name}</span>
                                    <span className="paramValue">{currentEl.params.output_f[idx]}{currentEl.params.f_unit ? ` ${currentEl.params.f_unit}` : ""}</span>
                                  </div>
                                ) : null
                              )}
                            </div>
                          </>
                        )}
                        {/* {currentEl.inputStreams?.length > 0 && currentEl.inputStreams.some((s: any) => s.streamAttribute) && (
                          <>
                            <h3 className="sectionTitle">入口流股</h3>
                            <div className="paramGrid">
                              {currentEl.inputStreams.map((s: any) => (
                                <div key={s.name} className="paramRow">
                                  <span className="paramLabel">{s.name}</span>
                                  <span className="paramValue">{s.streamAttribute}</span>
                                </div>
                              ))}
                            </div>
                          </>
                        )}

                        {currentEl.outputStreams?.length > 0 && currentEl.outputStreams.some((s: any) => s.streamAttribute) && (
                          <>
                            <h3 className="sectionTitle">出口流股</h3>
                            <div className="paramGrid">
                              {currentEl.outputStreams.map((s: any) => (
                                <div key={s.name} className="paramRow">
                                  <span className="paramLabel">{s.name}</span>
                                  <span className="paramValue">{s.streamAttribute}</span>
                                </div>
                              ))}
                            </div>
                          </>
                        )} */}

                        {currentEl.params?.Ns && currentEl.inputStreams && (
                          <>
                            <h3 className="sectionTitle">进料流股位置</h3>
                            <div className="paramGrid">
                              {renderFeedPositions(currentEl.params.Ns, currentEl.inputStreams)}
                            </div>
                          </>
                        )}

                        {currentEl.params?.No && currentEl.outputStreams && (
                          <>
                            <h3 className="sectionTitle">出料流股位置</h3>
                            <div className="paramGrid">
                              {renderProductPositions(currentEl.params.No, currentEl.outputStreams)}
                            </div>
                          </>
                        )}

                        {currentEl.params?.eff && currentEl.params.eff.length > 0 && (
                          <>
                            <h3 className="sectionTitle">塔板效率</h3>
                            <table style={effTableStyle.table}>
                              <thead>
                                <tr>
                                  <th style={effTableStyle.th}>起始塔板</th>
                                  <th style={effTableStyle.th}>结束塔板</th>
                                  <th style={effTableStyle.th}>塔板效率</th>
                                  <th style={effTableStyle.th}>塔板组分效率</th>
                                </tr>
                              </thead>
                              <tbody>
                                {currentEl.params.eff.map((e, idx) => (
                                  <tr key={idx}>
                                    <td style={effTableStyle.td}>{e.start}</td>
                                    <td style={effTableStyle.td}>{e.end}</td>
                                    <td style={effTableStyle.td}>{e.value}</td>
                                    <td style={effTableStyle.td}>
                                      {Array.isArray(e.spec) && e.spec.length > 0 ? (
                                        <div style={{ display: "inline-flex", flexDirection: "column", gap: 4, textAlign: "left" }}>
                                          {e.spec.map((sp: any, si: number) => {
                                            const mat = globalMaterials?.[Number(sp?.[0]) - 1];
                                            const matName = mat?.name || mat?.Name_ZH || mat?.chineseName || mat?.Molecular_formula || `组分${sp?.[0]}`;
                                            return (
                                              <span key={`spec-${si}`}>
                                                {matName}：{sp?.[1]}
                                              </span>
                                            );
                                          })}
                                        </div>
                                      ) : (
                                        <span style={{ color: "#999" }}>—</span>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </>
                        )}
                      </div>
                    ) : currentSt ? (
                      <div className="paramContent">
                        <h2 className="paramTitle">{currentSt.name} 参数</h2>
                      <div className="paramGrid">{renderParamRows(currentSt, "streams")}</div>

                        {currentSt.materials?.length > 0 && (
                          <>
                          <h2 className="paramTitle" style={{ marginTop: 20 }}>
                            组分摩尔分率
                          </h2>
                            <div className="paramGrid">
                              {renderComponentRows(currentSt.materials)}
                            </div>
                          </>
                        )}
                      </div>
                    ) : (
                      <div className="emptyTip"><Spin /></div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </ReactFlowProvider>
  );
};

export default Component;
